__turbopack_context__.v({
  "barContainer": "ProgressionBar-module__TDgq0W__barContainer",
  "highlighted": "ProgressionBar-module__TDgq0W__highlighted",
  "introText": "ProgressionBar-module__TDgq0W__introText",
  "midWeek": "ProgressionBar-module__TDgq0W__midWeek",
  "pointsEarnt": "ProgressionBar-module__TDgq0W__pointsEarnt",
  "progressionBar": "ProgressionBar-module__TDgq0W__progressionBar",
  "progressionBar__large": "ProgressionBar-module__TDgq0W__progressionBar__large",
  "shape": "ProgressionBar-module__TDgq0W__shape",
  "shapeContainer": "ProgressionBar-module__TDgq0W__shapeContainer",
  "sideBySide": "ProgressionBar-module__TDgq0W__sideBySide",
  "summaryText": "ProgressionBar-module__TDgq0W__summaryText",
  "summaryTextAlt": "ProgressionBar-module__TDgq0W__summaryTextAlt",
  "week": "ProgressionBar-module__TDgq0W__week",
  "weekLabel": "ProgressionBar-module__TDgq0W__weekLabel",
});
